import { initializeDayjs } from 'frontend-utils/utils/dayjs';

export function initialize(): void {
  initializeDayjs();
}

export default {
  name: 'dayjs',
  initialize,
};
